(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mini-cart"]) return;
  try {
    
  $(document).ready(function() {
    $.fn.digits = function() {
      return this.each(function() {
        $(this).text( $(this).text().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,") ); 
      })
    };
    update_mini_cart();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  var loadProductRecommendationsIntoSection = function(container_base) {
    var productRecommendationsSection = document.querySelector(container_base);
    if (productRecommendationsSection === null) { return; }
    var productId   = productRecommendationsSection.dataset.productId;
    var baseUrl     = productRecommendationsSection.dataset.baseUrl;
    var sectionType = productRecommendationsSection.dataset.sectionType;
    var limit       = productRecommendationsSection.dataset.limit;
    var requestUrl  = baseUrl + "?section_id=" + sectionType + "&product_id=" + productId + "&limit=" + limit;
    var request     = new XMLHttpRequest();
    request.open("GET", requestUrl);
    request.onload  = function() {
      if (request.status >= 200 && request.status < 300) {
        var container                                         = document.createElement("div");
        container.innerHTML                                   = request.response;
        console.log(container);
        productRecommendationsSection.parentElement.innerHTML = container.querySelector(container_base).innerHTML;
        const observer = lozad(); // lazy loads elements with default selector as '.lozad'
        observer.observe();
      }
    };
    request.send();
  };

  document.addEventListener("shopify:section:load", function(event) {
    if (event.detail.sectionId === ".product-recommendations") {
      loadProductRecommendationsIntoSection();
    }
  });
  loadProductRecommendationsIntoSection(".product-recommendations");

  } catch(e) { console.error(e); }
})();
})();
